import React from "react";
import styled from 'styled-components';

const Text = styled.p`
    margin-top: 16px;
    margin-bottom: 1rem;
    font-style: italic;
    color: rgba(1, 60, 92, .7);
    font-size: 0.9rem;
`;

const RegulatoryText = ({ children }: { children: React.ReactNode }) => (
    <Text>{children}</Text>
);

export { RegulatoryText };
